import React, { useRef, useEffect } from "react";
import "./SpotlightText.css";
import { Link } from "react-router-dom";

export default function SpotlightText() {
  const heroRef = useRef(null);      // the bottom "masked" title (local coords)
  const heroTopRef = useRef(null);   // the top text (full-screen / viewport coords)
  const glowRef = useRef(null);
  const rafRef = useRef(null);

  const target = useRef({
    cursorX: window.innerWidth / 2,
    cursorY: window.innerHeight / 2,
    maskX: 0,
    maskY: 0,
  });
  const current = useRef({ ...target.current });

  useEffect(() => {
    const hero = heroRef.current;
    const heroTop = heroTopRef.current;
    const glow = glowRef.current;

    if (!hero) return;

    // init mask center to the center of the hero element (relative coords)
    const rect = hero.getBoundingClientRect();
    target.current.maskX = Math.round(rect.width / 2);
    target.current.maskY = Math.round(rect.height / 2);
    current.current = { ...target.current };

    function handleMove(e) {
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      // global target for glow
      target.current.cursorX = clientX;
      target.current.cursorY = clientY;

      // relative to hero for mask (heroRef bounding box)
      const r = hero.getBoundingClientRect();
      target.current.maskX = Math.max(0, Math.min(r.width, clientX - r.left));
      target.current.maskY = Math.max(0, Math.min(r.height, clientY - r.top));
    }

    window.addEventListener("mousemove", handleMove);
    window.addEventListener("touchmove", handleMove, { passive: true });

    const ease = 0.12;
    function loop() {
      current.current.cursorX += (target.current.cursorX - current.current.cursorX) * ease;
      current.current.cursorY += (target.current.cursorY - current.current.cursorY) * ease;
      current.current.maskX += (target.current.maskX - current.current.maskX) * ease;
      current.current.maskY += (target.current.maskY - current.current.maskY) * ease;

      // move glow (global screen coords)
      if (glow) {
        glow.style.left = `${Math.round(current.current.cursorX)}px`;
        glow.style.top = `${Math.round(current.current.cursorY)}px`;
      }

      // set CSS vars for hero (local coords — mask anchored to heroRef box)
      if (hero) {
        hero.style.setProperty("--mask-x", `${Math.round(current.current.maskX)}px`);
        hero.style.setProperty("--mask-y", `${Math.round(current.current.maskY)}px`);

        // rotation for conic gradient (hero local)
        const r = hero.getBoundingClientRect();
        const dx = current.current.cursorX - (r.left + r.width / 2);
        const dy = current.current.cursorY - (r.top + r.height / 2);
        const angle = Math.atan2(dy, dx) * (180 / Math.PI);
        hero.style.setProperty("--gradient-rotation", `${angle}deg`);
      }

      // set CSS vars for heroTop (viewport coords — add hero's offset)
      if (heroTop && hero) {
        const heroRect = hero.getBoundingClientRect();
        const globalMaskX = Math.round(heroRect.left + current.current.maskX);
        const globalMaskY = Math.round(heroRect.top + current.current.maskY);
        heroTop.style.setProperty("--mask-x", `${globalMaskX}px`);
        heroTop.style.setProperty("--mask-y", `${globalMaskY}px`);
      }

      rafRef.current = requestAnimationFrame(loop);
    }

    rafRef.current = requestAnimationFrame(loop);

    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("touchmove", handleMove);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <div className="bg">


     <div className="spotlight-container">
  <h1 className="hero-top" ref={heroTopRef}>Balancor</h1>

  <h1 className="hero-title" ref={heroRef}>
    <span className="text-base">Balancor</span>
    <span className="text-overlay" data-text="Balancor">Balancor</span>
  </h1>

  <div className="cursor-glow" ref={glowRef} aria-hidden />

  <nav className="legal-links">
    <Link to="/impressum">Impressum</Link>
    <Link to="/datenschutz">Datenschutz</Link>
  </nav>
</div>




    </div>
  );
}
